import { CORES_DE_MARCADOR } from '@equiview/domain';

/**
 * A cor do adesivo colado no animal: as padrao do projeto e, se foi lida na
 * foto, a cor lida. A deteccao automatica procura por ela.
 */
export function CorDoAdesivo({
  valor,
  onMudar,
  desabilitado = false,
}: {
  valor: string;
  onMudar: (hex: string) => void;
  desabilitado?: boolean;
}) {
  const padrao = CORES_DE_MARCADOR.find((c) => c.hex === valor);
  const opcoes = padrao ? CORES_DE_MARCADOR : [...CORES_DE_MARCADOR, { hex: valor, rotulo: `Lida na foto (${valor})`, aviso: null }];
  return (
    <div className="space-y-1">
      <div role="radiogroup" aria-label="Cor do adesivo" className="flex flex-wrap gap-1.5">
        {opcoes.map((c) => (
          <button
            key={c.hex}
            type="button"
            role="radio"
            aria-checked={c.hex === valor}
            aria-label={c.rotulo}
            title={c.rotulo}
            disabled={desabilitado}
            onClick={() => onMudar(c.hex)}
            className={`alvo-toque grid size-8 place-items-center rounded-full border-2 ${
              c.hex === valor ? 'border-texto' : 'border-transparent'
            } disabled:opacity-45`}
          >
            <span className="block size-5 rounded-full border border-borda-forte" style={{ background: c.hex }} />
          </button>
        ))}
      </div>
      <p className="text-xs text-apagado">
        {padrao?.rotulo ?? `Cor lida na foto: ${valor}`}
        {padrao?.aviso ? ` — ${padrao.aviso}` : ''}
      </p>
    </div>
  );
}
